export default __webpack_public_path__ + "static/media/facebook.d6064c0d.svg";